import { get, put, post } from './api';

export const getEquipmentPlanning = async (season, year, type) => {
  const typeParam = type ? `&type=${type}` : '';
  return get(`admin/equipment-planning?season=${season}&year=${year}${typeParam}`);
};

export const updateInventory = async (itemName, quantity) => {
  return put('admin/inventory', { itemName, quantity });
};

export const checkoutEquipment = async (programId, itemName, quantity) => {
  return post('admin/equipment-checkout', { programId, itemName, quantity });
};

export const returnEquipment = async (checkoutId) => {
  return post('admin/equipment-return', { checkoutId });
};
